import React from "react";
import { Badge } from "../../../ui";
import { MessageBubble } from "./MessageBubble";
import { ToolCallDisplay } from "./ToolCallDisplay";

interface InteractionDisplayProps {
  interaction: any;
  index?: number;
}

export function InteractionDisplay({ interaction }: InteractionDisplayProps) {
  return (
    <div className="bg-muted rounded-lg p-4 space-y-3">
      {/* Input Messages */}
      {interaction.input_messages &&
      Array.isArray(interaction.input_messages) &&
      interaction.input_messages.length > 0 && (
        <div>
          <h5 className="text-xs font-semibold text-muted-foreground mb-2">Input Messages</h5>
          <div className="space-y-2">
            {interaction.input_messages.map((msg: any, msgIndex: number) => {
              // Handle tool responses
              if (
                msg.role === "tool" &&
                typeof msg.content === "object" &&
                msg.content.response
              ) {
                return (
                  <MessageBubble
                    key={msgIndex}
                    role={msg.role || "tool"}
                    content={msg.content.response}
                    type={msg.type || "tool_response"}
                  />
                );
              }

              return (
                <MessageBubble
                  key={msgIndex}
                  role={msg.role || "unknown"}
                  content={msg.content}
                  type={msg.type}
                />
              );
            })}
          </div>
        </div>
      )}

      {/* Output Messages */}
      {interaction.output_messages &&
      Array.isArray(interaction.output_messages) &&
      interaction.output_messages.length > 0 && (
        <div>
          <h5 className="text-xs font-semibold text-muted-foreground mb-2">Output Messages</h5>
          <div className="space-y-2">
            {interaction.output_messages.map((msg: any, msgIndex: number) => {
              const isToolCall = msg.type === "tool_call";

              if (isToolCall && typeof msg.content === "object") {
                return (
                  <MessageBubble
                    key={msgIndex}
                    role="tool_call"
                    content=""
                    type="tool_call"
                  >
                    <ToolCallDisplay toolCall={msg.content} />
                  </MessageBubble>
                );
              }

              return (
                <MessageBubble
                  key={msgIndex}
                  role="assistant"
                  content={msg.content}
                  type={msg.type}
                />
              );
            })}
          </div>
        </div>
      )}

      {/* Tools Available */}
      {interaction.tools_available &&
      Array.isArray(interaction.tools_available) &&
      interaction.tools_available.length > 0 && (
        <div>
          <h5 className="text-xs font-semibold text-muted-foreground mb-2">
            Tools Available ({interaction.tools_available.length})
          </h5>
          <div className="flex flex-wrap gap-2">
            {interaction.tools_available.map((tool: any, toolIndex: number) => (
              <Badge
                key={toolIndex}
                variant="outline"
                className="text-xs px-2 py-0.5"
              >
                {tool.name || `Tool ${toolIndex + 1}`}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
